import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { TextHighlighter, SuggestDesktopList, SuggestionDesktopDefaultItem } from '../../internal/components';
import { DropdownPopover } from '../../../popover';
import { useIconMargin, useSuggestSelectedItem } from '../../internal/hooks';
import { SuggestionTitleItem } from '../../internal/components/SuggestionTitleItem';
import { Outside } from '../../../services';
import { SuggestionTextItem } from '../../internal/components/SuggestionTextItem';
import { SUGGEST_PROP_DEFAULTS } from '../../internal/constants';
import { useMaxLinesCssVarable } from '../../internal/hooks/useMaxLinesCssVarable';
import { useSuggestMouseEvents } from '../../internal/hooks/useSuggestMouseEvents';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
var suggestItemComponentMap = {
  default: SuggestionDesktopDefaultItem,
  title: SuggestionTitleItem
};
export var SuggestDesktop = function SuggestDesktop(props) {
  var _props$maxHeight;
  var onSelect = props.onSelect,
    onClose = props.onClose;
  var listBoxRef = React.useRef(null);
  var suggestionsChildrenRef = React.useRef(null);
  useMaxLinesCssVarable({
    ref: listBoxRef,
    maxLines: props.maxLines,
    open: props.open
  });
  var _useSuggestSelectedIt = useSuggestSelectedItem(props, {
      suggestionsChildrenRef: suggestionsChildrenRef,
      listBoxRef: listBoxRef
    }),
    setSelectedItemIndex = _useSuggestSelectedIt.setSelectedItemIndex,
    selectedItemIndex = _useSuggestSelectedIt.selectedItemIndex;
  var mouseEventProps = useSuggestMouseEvents(setSelectedItemIndex);
  var _useIconMargin = useIconMargin(props.suggestions),
    getIconMarginForItem = _useIconMargin.getIconMarginForItem,
    setTitleItemRefByIndex = _useIconMargin.setTitleItemRefByIndex;
  var onItemClick = React.useCallback(function (item, index) {
    return function () {
      setSelectedItemIndex(index);
      onSelect === null || onSelect === void 0 || onSelect(item, {
        source: 'click'
      });
    };
  }, [setSelectedItemIndex, onSelect]);
  var onOutsideClick = React.useCallback(function () {
    return onClose === null || onClose === void 0 ? void 0 : onClose({
      source: 'outsideClick'
    });
  }, [onClose]);
  var insideRefs = React.useMemo(function () {
    return [listBoxRef, suggestionsChildrenRef];
  }, []);
  var isPopupListShown = props.suggestions.length || props.emptyListText;
  var NoItemsComponent = !props.suggestions.length && props.emptyListText && /*#__PURE__*/_jsx(SuggestionTextItem, {
    children: props.emptyListText
  });
  return /*#__PURE__*/_jsx(DropdownPopover, {
    open: props.open,
    sameWidth: "width",
    content: isPopupListShown && /*#__PURE__*/_jsx(Outside, {
      onOutside: onOutsideClick,
      insideRefs: insideRefs,
      children: /*#__PURE__*/_jsxs(SuggestDesktopList, {
        ref: listBoxRef,
        maxHeight: (_props$maxHeight = props.maxHeight) !== null && _props$maxHeight !== void 0 ? _props$maxHeight : SUGGEST_PROP_DEFAULTS.maxHeight,
        children: [NoItemsComponent, props.suggestions.map(function (suggestion, i) {
          var _suggestion$type;
          var ItemComponent = suggestItemComponentMap[(_suggestion$type = suggestion.type) !== null && _suggestion$type !== void 0 ? _suggestion$type : SUGGEST_PROP_DEFAULTS.itemType];
          return /*#__PURE__*/_createElement(ItemComponent, _objectSpread(_objectSpread({}, suggestion), {}, {
            key: i,
            type: suggestion.type,
            iconMargin: getIconMarginForItem(suggestion),
            ref: suggestion.type === 'title' ? setTitleItemRefByIndex(i) : undefined,
            onMouseMove: mouseEventProps.onMouseMove(i),
            onMouseLeave: mouseEventProps.onMouseLeave,
            onMouseEnter: mouseEventProps.onMouseEnter,
            isSelected: selectedItemIndex === i,
            onClick: onItemClick(suggestion, i),
            variant: "desktop"
          }), /*#__PURE__*/_jsx(TextHighlighter, {
            highlightValue: props.highlightValue,
            children: suggestion.title
          }));
        })]
      })
    }),
    children: /*#__PURE__*/_jsx("div", {
      ref: suggestionsChildrenRef,
      "data-testid": "suggest-children",
      children: props.children
    })
  });
};
SuggestDesktop.displayName = 'SuggestDesktop';